import {
  tenantTeamListSchema,
  tenantInviteSchema,
  tenantAuthMeSchema,
  type AcceptTenantInviteRequest,
  type CreateTenantInviteRequest,
  type TenantTeamRow,
} from '@console/types'
import { z } from 'zod'
import { customerAppDelete, customerAppGet, customerAppPost } from '../customer-app.js'

/** `TST-001` finding 2 — see the doc comment on `tenantTeamListSchema` itself. */
export async function fetchTenantTeam(): Promise<TenantTeamRow[]> {
  return customerAppGet('/api/v1/tenant-team', tenantTeamListSchema)
}

export async function createTenantInvite(body: CreateTenantInviteRequest) {
  return customerAppPost('/api/v1/tenant-invites', body, tenantInviteSchema)
}

/**
 * `TST-001` finding 3. Accept's own response is not a bare member record —
 * it's the same `{user, tenant}` shape `/me` answers (live-observed), which
 * is also why `useAcceptTenantInvite`'s `onSuccess` was already safe to
 * invalidate rather than cache directly (finding 6's fix, same reasoning).
 */
export async function acceptTenantInvite(inviteId: string, body: AcceptTenantInviteRequest) {
  return customerAppPost(
    `/api/v1/tenant-invites/${encodeURIComponent(inviteId)}/accept`,
    body,
    tenantAuthMeSchema,
  )
}

export async function revokeTenantInvite(inviteId: string): Promise<void> {
  await customerAppDelete(
    `/api/v1/tenant-invites/${encodeURIComponent(inviteId)}`,
    z.looseObject({}),
  )
}

export async function removeTenantMember(userId: string): Promise<void> {
  await customerAppDelete(`/api/v1/tenant-team/${encodeURIComponent(userId)}`, z.looseObject({}))
}
